'use client'

import FormCheckbox from '@tebuto/forms/Checkbox'
import { SimpleFormikEditor } from '@tebuto/forms/editor/SimpleFormikEditor'
import FormField from '@tebuto/forms/Field'
import { Label } from '@tebuto/forms/Label'
import TebutoModal from '@tebuto/modals/TebutoModal'
import { object, string } from 'yup'

export interface FeatureForm {
    title: string
    description: string
    isAnonymous: boolean
}

interface FeatureModalProps {
    open: boolean
    setOpen: (open: boolean) => void
    submitHandler: (values: FeatureForm) => Promise<void>
    initialValues?: FeatureForm
    isCreation?: boolean
}

const newFeatureValidationSchema = object().shape({
    title: string()
        .required('Bitte geben Sie einen Titel an.')
        .min(10, 'Der Titel sollte mindestens 10 Zeichen lang sein.')
        .max(50, 'Der Titel sollte maximal 50 Zeichen lang sein. Bitte führen Sie stattdessen eine Beschreibung an.'),
    description: string()
        .required('Bitte geben Sie eine Beschreibung an.')
        .min(
            50,
            'Die Beschreibung sollte mindestens 50 Zeichen lang sein, damit Andere verstehen, worum es bei Ihrem Vorschlag geht.'
        )
})

export default function FeatureModal({
    open,
    setOpen,
    submitHandler,
    initialValues = { title: '', description: '', isAnonymous: false },
    isCreation = false
}: FeatureModalProps) {
    async function confirmHandler(values: FeatureForm) {
        await submitHandler(values)
        setOpen(false)
    }

    return (
        <TebutoModal<FeatureForm>
            isOpen={open}
            closeHandler={() => setOpen(false)}
            confirmButtonText={(isCreation && 'Erstellen') || 'Speichern'}
            showResetButton={false}
            title="Neues Feature vorschlagen"
            className="max-w-3xl! md:h-[90vh]"
            initialValues={initialValues}
            onSubmit={confirmHandler}
            validationSchema={newFeatureValidationSchema}
        >
            <div className="flex flex-col gap-6 md:h-full">
                <FormField label={'Titel'} tabIndex={0} name={'title'} />
                <FormCheckbox
                    label={(isCreation && 'Anonym erstellen') || 'Anonym'}
                    description="Wenn Sie dieses Feature als anonym kennzeichnen, werden wir Ihren Namen nicht für andere Plattform-Nutzer veröffentlichen."
                    name="isAnonymous"
                />
                <div className="flex flex-col md:min-h-0 md:flex-1">
                    <Label htmlFor={'description'} mandatory={true}>
                        Beschreibung
                    </Label>
                    <div className="md:min-h-0 md:flex-1">
                        <SimpleFormikEditor
                            tabIndex={-1}
                            defaultValue={initialValues.description}
                            accessorKey={'description'}
                            htmlHeadingLevelOffSet={1}
                            maxHeight={undefined}
                            contentClassName="max-h-[42vh] md:max-h-full"
                        />
                    </div>
                </div>
            </div>
        </TebutoModal>
    )
}
